import {Component} from '@angular/core'
import {LoadingService} from '../../services/utils/loading.service'

@Component({
    selector: 'app-loader',
    templateUrl: 'loader.component.html',
    styleUrls: [ '../../app.component.scss', './loader.component.scss' ],
})

export class LoaderComponent {

    show: boolean

    constructor(private loading : LoadingService) {
        this.show = false
    }

    ngOnInit() {
        this.loading.$load.subscribe( (val) => {
            this.show = val
        })
    }

}
